import { Loader } from "uikit"
import React, { Component } from "react"
import { Modal } from "semantic-ui-react"
class AccountsConnector extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isPending: false,
      isRemoteContentLoading: true
    }
    this.callbackId = (Math.random().toString(36) + "00000000000000").slice(
      2,
      12
    )
  }

  handleDone = (success = true) => {
    if (success) {
      this.setState({
        isPending: true
      })
      return this.props.onSuccess()
    } else {
      this.setState({
        isPending: false
      })
      return this.props.onFailure()
    }
  }

  handleMessage = event => {
    if (event.data && typeof event.data === "string") {
      try {
        const data = JSON.parse(event.data)
        const success = data.status === "failure" ? false : true
        this.handleDone(success)
      } catch (error) {
        this.handleDone()
      }
    }
  }

  componentDidMount() {
    window.addEventListener("message", this.handleMessage)
    window.trackEvent("link-accounts")
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.handleMessage)
  }

  render = () => {
    const { getFastLink } = this.props
    return (
      <Modal
        defaultOpen={true}
        closeOnDimmerClick={false}
        size="small"
        onUnmount={() => {
          const bodyElement = document.getElementsByTagName("body")[0]
          ;["dimmable", "dimmed", "scrolling"].forEach(className => {
            bodyElement.classList.remove(className)
          })
        }}
      >
        <Modal.Content style={{ padding: "0" }}>
          {/* <Loader text="Updating Accounts" active={this.state.isPending} /> */}
          <Loader
            text="Preparing secure connection..."
            active={this.state.isRemoteContentLoading}
          />
          <iframe
            onLoad={() => {
              setTimeout(() => {
                const bodyElement = document.getElementsByTagName("body")[0]
                if (bodyElement.classList.contains("scrolling")) {
                  ;["dimmable", "dimmed", "scrolling"].forEach(className => {
                    bodyElement.classList.add(className)
                  })
                }
              }, 0)
              this.setState({ isRemoteContentLoading: false })
            }}
            title="FastLink"
            src={getFastLink(this.callbackId)}
            frameBorder="0"
            style={{
              minHeight: "47em",
              width: "100%"
            }}
          />
        </Modal.Content>
      </Modal>
    )
  }
}

export default AccountsConnector
